export class Theme {
    colors = {
        body: '#f3f3f4',
        primary: '#1ab394',
        primaryHover: '#1a7794',
        secondary: '#1a7794',
        menuBackgroundColor: '#ffffff',
        menuFontColor: '#767677',
        selectedMenuItemFontColor: '#767677'
    };
    miniLogo: string;
    obj;

    constructor(
        public id: number = null,
        public name: string = '',
        public logo: string = '',
        public settings: string = '{}',
        public companies: number[] = [],
        public createdAt: string = '',
        public createdBy: string = null,
        public buildingId: number = undefined,
        public corporationNumberId: number = undefined,
        public company: number = undefined
    ) {
        try {
            this.obj = JSON.parse(this.settings);
        } catch (e) {
            console.error('Wrong settings format.');
        }
        if (typeof this.obj === 'object') {
            if (this.obj.colors) {
                this.colors = this.obj.colors;
                this.colors.body = this.obj.colors.body;
                this.colors.primary = this.obj.colors.primary;
                this.colors.primaryHover = this.obj.colors.primaryHover;
                this.colors.secondary = this.obj.colors.secondary ? this.obj.colors.secondary : '#1a7794';
                this.colors.menuBackgroundColor = this.obj.colors.menuBackgroundColor ? this.obj.colors.menuBackgroundColor : '#ffffff';
                this.colors.menuFontColor = this.obj.colors.menuFontColor ? this.obj.colors.menuFontColor : '#767677';
                this.colors.selectedMenuItemFontColor = this.obj.colors.selectedMenuItemFontColor ? this.obj.colors.selectedMenuItemFontColor : '#767677';
            }
            if (this.obj.miniLogo) this.miniLogo = this.obj.miniLogo;
        }
    }
}

export class Company {
    id: number = null;
    name: string = '';
    email: string = '';
    address: string = '';
    phone: string = '';
    theme: number = null;
    offices: Array<Office> = [];
    primaryContact: string = '';
    checked: boolean = false;
    filtered: boolean = false;
    numberOfProperties: number = null;
    loginpage = '';
    logoutUrl = '';

    constructor(data: any = {}, isChecked: boolean = false) {
        this.setProperty('id', data.id);
        this.setProperty('name', data.name);
        this.setProperty('email', data.email);
        this.setProperty('address', data.address);
        this.setProperty('phone', data.phone);
        this.setProperty('theme', data.theme);
        this.setProperty('offices', data.offices);
        this.setProperty('primaryContact', data.primaryContact);
        this.setProperty('checked', isChecked);
        this.setProperty('numberOfProperties', data.numberOfProperties);
        this.setProperty('loginpage', data.loginpage);
        this.setProperty('logoutUrl', data.logoutUrl);
        this.setProperty('filtered', data.filtered);
    }

    private setProperty(key, value) {
        this[key] = value || this[key];
    }
}

export class Property {
    id: number = null;
    name: string = '';
    address: string = '';
    postalCode: string = '';
    propertyNumber: number = null;
    propertyType: string = '';
    purpose: string = '';
    timezone: string = '';
    numberOfUnits: number = null;
    numberOfResidents: number = null;
    numberOfUsers: number = null;
    numberOfEmails: number = null;
    numberOfInvitations: number = null;
    createdAt: string = '';
    updatedAt: string = '';
    suites: Array<number> = [];
    contacts: Array<Object> = [];
    checked: boolean = false;
    companyId: number = null;
    companyName: string = '';
    corporationNumber: number = null;
    latitude: number = null;
    longitude: number = null;
    canEdit: boolean;
    isCanEdit: boolean;
    syncLuxerone: boolean;
    snailIntegration: boolean;
    parcelOneIntegration: boolean;

    constructor(data: any = {}, isChecked: boolean = false) {
        this.setProperty('id', data.id);
        this.setProperty('buildings', data.buildings);
        this.setProperty('building', data.id);
        this.setProperty('name', data.name);
        this.setProperty('address', data.address);
        this.setProperty('postalCode', data.postalCode);
        this.setProperty('propertyNumber', data.propertyNumber);
        this.setProperty('propertyType', data.propertyType);
        this.setProperty('purpose', data.purpose);
        this.setProperty('timezone', data.timeZone);
        this.setProperty('numberOfUnits', data.numberOfUnits);
        this.setProperty('numberOfResidents', data.numberOfResidents);
        this.setProperty('numberOfUsers', data.numberOfUsers);
        this.setProperty('numberOfEmails', data.numberOfEmails);
        this.setProperty('numberOfInvitations', data.numberOfInvitations);
        this.setProperty('createdAt', data.createdAt);
        this.setProperty('suites', data.suites);
        this.setProperty('contacts', data.contacts);
        this.setProperty('checked', isChecked);
        this.setProperty('companyId', data.companyId);
        this.setProperty('companyName', data.companyName);
        this.setProperty('corporationNumber', data.corporationNumber);
        this.setProperty('latitude', +data.latitude);
        this.setProperty('longitude', +data.longitude);
        this.setProperty('updatedAt', data.updatedAt);
        this.setProperty('syncLuxerone', data.syncLuxerone);
        this.setProperty('snailIntegration', data.snailIntegration);
        this.setProperty('parcelOneIntegration', data.parcelOneIntegration);
    }

    private setProperty(key, value) {
        if (!value) return delete this[key];
        this[key] = value || this[key];
    }
}

export class User {
    id: number = null;
    email: string = '';
    fullName: string = '';
    firstName: string = '';
    lastName: string = '';
    buildingsManager: Array<any> = [];
    company: Company;
    userType: string = '';
    phones: Array<any> = [];
    username: string = '';
    userRoles: string = '';
    lastLogin: string = '';
    lastActivity: any = null;
    isActive: boolean = false;
    buildingPropertyManager: Array<any> = [];
    corporationNumberPropertyManager: Array<any> = [];
    sendInvitationEmail: boolean = false;
    isInvited: boolean = false;
    realStatus: string = '';
    suiteUsers: Array<any> = [];
    isLocked: boolean;

    constructor(data: any = {}) {
        this.setProperty('id', data.id);
        this.setProperty('email', data.email);
        this.setProperty('fullName', data.fullName);
        this.setProperty('firstName', data.fullName && data.fullName.split(' ')[0]);
        this.setProperty('lastName', data.fullName && data.fullName.split(' ').splice(1).join(' '));
        this.setProperty('buildingsManager', data.buildingPropertyManager);
        if (data.company) {
            this.setProperty('company', new Company(data.company));
        }
        this.setProperty('userType', data.userType);
        this.setProperty('phones', data.phones);
        this.setProperty('username', data.username);
        this.setProperty('userRoles', data.userRoles);
        this.setProperty('isActive', data.isActive);
        this.setProperty('isInvited', data.isInvited);
        this.setProperty('isLocked', data.isLocked);
        this.setProperty('sendInvitationEmail', data.sendInvitationEmail);
        this.setProperty('lastLogin', data.lastLogin);
        this.setProperty('lastActivity', data.lastActivity);
        this.setProperty('buildingPropertyManager', data.buildingPropertyManager);
        this.setProperty('realStatus', data.realStatus);
        this.setProperty('suiteUsers', data.suiteUsers);
    }

    private setProperty(key, value) {
        this[key] = value || this[key];
    }
}

export class Office {
    constructor(
        public id: number = null,
        public name: string = '',
        public phone: string = '',
        public members: { name: string, phone: string }[] = [{name: '', phone: ''}],
        public company: number = null,
    ) {
    }
}

export class BuildingPropertyManager {
    constructor(
        public id: number,
        public buildingId: number,
        public user: number
    ) {
    }
}

export class AccessRights {
    a: null | 1 = null;
    c: null | 1 = null;
    d: null | 1 = null;
    r: null | 1 = null;
    s: null | 1 = null;
    u: null | 1 = null;
}

export class UserServiceAccessSettings {
    amenity?: AccessRights = new AccessRights();
    auth?: AccessRights = new AccessRights();
    bldn?: AccessRights = new AccessRights();
    daily_report?: AccessRights = new AccessRights();
    documents?: AccessRights = new AccessRights();
    email_merge?: AccessRights = new AccessRights();
    inc_report?: AccessRights = new AccessRights();
    key_log?: AccessRights = new AccessRights();
    parcels?: AccessRights = new AccessRights();
    parking_pass?: AccessRights = new AccessRights();
    pass_on_log?: AccessRights = new AccessRights();
    report_builder?: AccessRights = new AccessRights();
    service_request?: AccessRights = new AccessRights();
}

export class UserRole {
    id: number = null;
    name = '';
    settings: UserServiceAccessSettings = {};
    user: number = null;
    numberOfUsers = 0;
    createdAt = '';
    buildingPropertyManagers: Array<number> = [];
    checked = false;
    corporationNumber = '';
    corporationNumberId: number = null;
    dashboards: any[];

    constructor(data: any = {}, isChecked: boolean = false) {
        this.setProperty('id', data.id);
        this.setProperty('name', data.name);
        this.setProperty('settings', data.settings);
        this.setProperty('createdAt', data.createdAt);
        this.setProperty('user', data.user);
        this.setProperty('usersData', data.usersData);
        this.setProperty('numberOfUsers', data.numberOfUsers);
        this.setProperty('buildingPropertyManagers', data.buildingPropertyManagers);
        this.setProperty('corporationNumber', data.corporationNumber);
        this.setProperty('corporationNumberId', data.corporationNumberId);
        this.setProperty('dashboards', data.dashboards);
        this.setProperty('checked', isChecked);
    }

    private setProperty(key, value) {
        this[key] = value || this[key];
    }
}









// WEBPACK FOOTER //
// /app/src/app/types/admin-data.types.ts